import React from 'react';
import * as icons from '@boxine/tonies-ui/icons';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Icon from '../../Icon';
const TextWithMargin = styled.span `
  margin-right: 0.5rem;
`;
const Wrapper = styled.span `
  align-items: center;
  color: ${props => props.theme.colors.primary};
  display: flex;
  justify-content: center;
  /* = Line-height of text, required for non-text variation */
  max-height: 1.4rem;

  &:hover {
    color: ${props => props.theme.colors['primary-hover']};
  }
`;
const StyledIcon = styled(Icon) `
  height: auto;
  width: 1.5625rem;
  /**
   * Required to prevent Safari from cutting the Icon (probably due to rounding
   * errors) on certain combinations of screen density/screen size.
   */
  transform: translate3d(0, 0, 0);
`;
export function LoginLink({ showLabel = false }) {
    const { t } = useTranslation('MainNavigation');
    return (React.createElement(Wrapper, null,
        showLabel && React.createElement(TextWithMargin, null, t('Login')),
        React.createElement(StyledIcon, { fillAll: "", fill: "", type: icons.userCircle })));
}
